import { render, staticRenderFns } from "./ProductSettings.vue?vue&type=template&id=c476fae8&scoped=true"
import script from "./ProductSettings.vue?vue&type=script&lang=js"
export * from "./ProductSettings.vue?vue&type=script&lang=js"
import style0 from "./ProductSettings.vue?vue&type=style&index=0&id=c476fae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c476fae8",
  null
  
)

export default component.exports